export class TaskQueue {
  private queue: (() => Promise<void>)[] = [];
  private activeTasks: number = 0;
  private concurrencyLimit: number;
  private isCancelled: boolean = false;

  constructor(concurrencyLimit: number = 1) {
    this.concurrencyLimit = concurrencyLimit;
  }

  async addTask(task: () => Promise<void>): Promise<void> {
    if (this.isCancelled) {
      console.warn('Task queue is cancelled. No new tasks are accepted.');
      return;
    }
    this.queue.push(task);
    this.processQueue();
  }

  private async processQueue(): Promise<void> {
    if (this.activeTasks >= this.concurrencyLimit || this.isCancelled) {
      return;
    }
    const task = this.queue.shift();
    if (task) {
      this.activeTasks++;
      try {
        await task();
      } catch (error) {
        console.error('Task failed', error);
      } finally {
        this.activeTasks--;
        this.processQueue();
      }
    }
  }

  cancel(): void {
    this.isCancelled = true;
    this.queue = [];
    console.log('Task queue has been cancelled and cleared.');
  }

  reset(): void {
    this.isCancelled = false;
    console.log('Task queue has been reset.');
  }
}
